import {CustomerDTO} from './customerDTO.interface';
import {BaseIntDTO} from "./_baseIntDTO.interface";

export interface PlatformDTO extends BaseIntDTO {
  platformName?: string;
  odometerUnits?: number;
  defaultUnit?: number;
  customers?: CustomerDTO[];
}
